import type {ComponentType} from 'react';

import loadable from '@loadable/component';
import React from 'react';
import {Route} from 'react-router-dom';

import getSharedLoader from '../lib/router/getSharedLoader';
import ConfirmEmailPage from './ConfirmEmailPage';
import ConfirmResetPassword from './ConfirmResetPassword';
import LoginPage from './LoginPage';
import MyPageRoutes from './MyPageRoutes';
import ResetPassword from './ResetPassword';
import SignupPage from './SignupPage';

const AppLayout = loadable(() => import('../layouts/app'));

export default (
  <Route path="/app/">
    <Route Component={AppLayout as ComponentType}>
      <Route
        Component={SignupPage as ComponentType}
        key="signup"
        loader={getSharedLoader({
          loadableRoot: SignupPage,
        })}
        path="signup"
      />
      <Route
        Component={LoginPage as ComponentType}
        key="login"
        loader={getSharedLoader({loadableRoot: LoginPage})}
        path="login"
      />
      <Route
        Component={ResetPassword as ComponentType}
        key="reset-password"
        loader={getSharedLoader({
          loadableRoot: ResetPassword,
        })}
        path="reset-password"
      />
      <Route
        Component={ConfirmResetPassword as ComponentType}
        key="confirm-reset-password"
        loader={getSharedLoader({
          loadableRoot: ConfirmResetPassword,
        })}
        path="confirm-reset-password"
      />
      <Route
        Component={ConfirmEmailPage as ComponentType}
        key="confirm-email-signup"
        loader={getSharedLoader({
          loadableRoot: ConfirmEmailPage,
        })}
        path="confirm-email-signup"
      />
    </Route>
    {MyPageRoutes}
  </Route>
);
